import React from 'react';
import './Footer.css';

const Landing = () => {
    return(
        <div className="page-footer">
            <footer className="pv2 ph3 ph5-m ph6-l white-80">
                <small className="f6 db tc">© 2024 <b className="ttu">TBayShinny</b></small>
                <div className="tc mt3">
                    <a href="mailto:admin@tbayshinny.com" target="_top" className="f6 dib ph2 link mid-gray dim">Contact Us</a> 
                    {/* <a href="/language/" title="Language" >Contact Us</a> */}
                    {/* <a href="/terms/"    title="Terms" className="f6 dib ph2 link mid-gray dim">Terms of Use</a>
                    <a href="/privacy/"  title="Privacy" className="f6 dib ph2 link mid-gray dim">Privacy</a> */}
                </div>
            </footer>
        </div>
    );
}

export default Landing;


// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js